import React, { useContext } from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import CommonCompleteCard from '../../uiParts/card/CommonCompleteCard';
import Header from '../../uiParts/menu/Header';
import { gray80 } from '../../../constants/colors';
import MetaTitle from '../../utils/MetaTitle';
import { headerHeight, spHeaderHeight } from '../../../constants/location';
import { AuthContext } from '../../../contexts/auth';

const styles = {
  background: {
    width: '100%',
    height: '100vh',
  },
  header: {
    height: headerHeight,
    position: 'fixed',
    '@media screen and (max-width:960px)': {
      height: spHeaderHeight,
      width: '100%',
      zIndex: '100',
    },
  },
  icon: {
    fontSize: '56px',
    color: gray80,
    mb: 3,
    '@media screen and (max-width: 600px)': {
      mb: 2,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '-webkit-fill-available',
    paddingTop: headerHeight,
    '@media (max-width: 600px)': {
      paddingTop: '50%',
      height: 'auto',
      marginLeft: '16px',
      marginRight: '16px',
    },
  },
};

const PasswordChangeComplete = (): React.ReactElement => {
  const { user } = useContext(AuthContext);
  const isLoggedIn = Boolean(user);

  const icon = <CheckCircleIcon sx={styles.icon} />;
  const title = isLoggedIn ? 'パスワードを変更しました' : 'パスワードを再設定しました';
  const textAligin = 'center';
  const description = isLoggedIn ? '' : '新しいパスワードでログインしてください。';
  const buttonText = isLoggedIn ? 'アカウント管理へ' : 'ログインへ';
  const buttonLink = isLoggedIn ? '/company' : '/';

  return (
    <Box sx={styles.background}>
      <MetaTitle />
      <Box sx={styles.header}>
        <Header />
      </Box>
      <Box sx={styles.container}>
        <CommonCompleteCard
          icon={icon}
          title={title}
          textAligin={textAligin}
          description={description}
          buttonText={buttonText}
          buttonLink={buttonLink}
        />
      </Box>
    </Box>
  );
};

export default PasswordChangeComplete;
